// var $ = require('jquery')

// This is your plugin object. It can be exported to be used anywhere.
const MyI18NLoader = {

  name: 'I18N',
  install (Vue, options) {
    // We call Vue.mixin() here to inject functionality into all components.
    // var cmp = this
    Vue.i18n.add('de', this.data.translationsDe)
    Vue.i18n.add('en', this.data.translationsEn)
    Vue.i18n.set('de')
    /*
    if (Vue.config.I18N_LOAD) {
      console.log('Load i18n ' + Vue.config.I18N_APP_NAME)
      Vue.prototype.$api.getJQuery().getJSON(Vue.config.host + '/I18N/export/' + Vue.config.I18N_APP_NAME, function (data) {
        Vue.i18n.add('de', data.localeDE)
        Vue.i18n.add('en', data.localeEN)
        Vue.i18n.set('de')
        if (cmp.starter) {
          cmp.starter()
        }
      })
    }
    */

    // set the start locale to use
    Vue.mixin({
      // Anything added to a mixin will be injected into all components.
      // In this case, the mounted() method runs when the component is added to the DOM.
      mounted () {
      }
    })
  },
  data: {
    'translationsDe': {
      'spakaberlin_loginParticipantNameLabel': 'PIN',
      'spakaberlin_loginParticipantPasswordLabel': 'TAN',
      'spakaberlin_loginParticipantTitle': 'Bitte loggen Sie sich per PIN und TAN ein',
      'spakaberlin_loginSubmit': 'Anmelden',
      'examenis_loginParticipantNameLabel': 'PIN',
      'examenis_loginParticipantPasswordLabel': 'TAN',
      'examenis_loginParticipantTitle': 'Bitte loggen Sie sich per PIN und TAN ein',
      'examenis_loginSubmit': 'Anmelden',
      'edologic_loginParticipantNameLabel': 'PIN',
      'edologic_loginParticipantPasswordLabel': 'TAN',
      'edologic_loginParticipantTitle': 'Bitte loggen Sie sich per PIN und TAN ein',
      'edologic_loginSubmit': 'Anmelden',
      'loginParticipantNameLabel': 'FH-Kennung',
      'loginParticipantPasswordLabel': 'Passwort',
      'loginParticipantTitle': 'Bitte loggen Sie sich mit Ihrer FH-Kennung und Passwort ein',
      'logInTitle': 'Examenis 2019',
      'BUTT_NAV_BACK': 'zurück',
      'loginUserNameLabel': 'Username',
      'loginPasswordLabel': 'Passwort',
      'loginSubmit': 'Anmelden',
      'Login.versionTitle': 'Version',
      'Login.version': '1.0',
      'AllowMyItemsToOpen': 'Darf eigene Fragen öffnen',
      'AllowMyItemsToEdit': 'Darf eigene Fragen bearbeiten',
      'AllowMyItemsToCopy': 'Darf eigene Fragen kopieren',
      'AllowMyExamsToOpen': 'Darf eigene Prüfungen ansehen',
      'AllowMyExamsToEdit': 'Darf eigene Prüfungen bearbeiten',
      'AllowMyExamsToCopy': 'Darf eigene Prüfungen kopieren',
      'AllowMyExamsToList': 'Darf eigene Prüfungen auflisten',
      'AllowMyTestsToList': 'Darf eigene Bögen auflisten',
      'AllowMyTestsToCast': 'Darf eigene Bögen nach Prüfung wandeln',
      'AllowMyTestsToEdit': 'Darf eigene Bögen bearbeiten',
      'AllowMyTestsToGrade': 'Darf eigene Bögen auswerten',
      'AllowMyItemsToList': 'Darf eigene Fragen auflisten',
      'AllowMySurveyToList': 'Darf eigene Umfragen auflisten',
      'AllowMySurveyToEdit': 'Darf eigene Umfragen bearbeiten',
      'AllowMySurveyToCopy': 'Darf eigene Umfragen kopieren',
      'AllowMySurveyToPrint': 'Darf eigene Umfragen drucken',
      'accountTitleLogin': 'Username',
      'LABEL_FIRSTNAME': 'Vorname',
      'LABEL_EMAIL': 'E-Mail'
    },
    'translationsEn': {
    }
  }
}
export default MyI18NLoader



// WEBPACK FOOTER //
// ./src/components/I18N/i18n.js